import { RegionId } from "./generated/enums";
import { IManureType } from "./models/omnia";
import { IManureStock } from "./models/stock";
import { isUndefinedOrNull } from "./utils/utils";

export interface IMmPlan {

    MmPlanId: number;

    RainwaterOpenYards?: number;
    RainwaterRoofs?: number;
    RainwaiterUncoveredStores?: number;
    RainfallOctFebAvg: number;
    RainfallOctMarAvg: number;

    StorageOnSuitableFieldSites?: number;

    FarmTotalArea?: number;
    FarmNPermitted?: number;
    FarmNProducedByLivestock?: number;
    FarmNMayBeImported?: number;
    FarmNImported?: number;
    FarmNMustBeExported?: number;
    FarmNExported?: number;
    FarmNLoading?: number;

    SlurryStorage?: number;
    SlurryProducedInClosedPeriod?: number;
    SlurryImport?: number;
    SlurryExport?: number;
    SlurryExportClosedPeriod?: number;
    SlurryStorageRequired?: number;
    SlurryStorageRequiredClosedPeriod?: number

    PoultryStorage?: number;
    PoultryManureProducedInClosedPeriod?: number;
    PoultryImport?: number;
    PoultryExport?: number;
    PoultryStorageRequirement?: number;

    StorageUnverified?: boolean;

    LivestockUnverified?: boolean;

}

export interface IMmExport {
    MmPlanId: number;
    MmExportId?: number;
    ManureStockId?: number;
    ManureStock?: IManureStock;
    Amount?: number;
    Date: Date;
    TradingName?: string;
    Address?: string;
}

const manureTypeColors = [
    {
        ids: [1, 2, 14, 15, 16, 17, 18, 19, 20, 21],
        color: [47, 57, 63]
    },
    {
        ids: [7, 8, 11, 12],
        color: [143, 104, 59]
    },
    {
        ids: [10],
        color: [230, 230, 230]
    },
    {
        ids: [9],
        color: [163, 125, 79]
    },
    {
        ids: [3, 4, 22, 23, 24, 25, 26],
        color: [247, 201, 241]
    },
    {
        ids: [5, 6],
        color: [230, 230, 230]
    },
    {
        ids: [13],
        color: [110, 110, 110]
    },
    {
        ids: [48, 49],
        color: [102, 204, 255]
    },
    {
        ids: [55, 56, 57, 58, 59, 60],
        color: [20, 52, 43]
    }
];

export function getManureTypeColor(manureTypeId: number): number[] {

    var id = manureTypeId;

    var color = manureTypeColors.find(s => s.ids.indexOf(id) !== -1);

    if (color) {
        return color.color;
    }

    return [224, 224, 224];
}

export function isBlendType(type: IManureType) {

    if (type) {

        var id = type.InvariantId || type.ManureTypeId;

        switch (id) {

            case 48:
            case 49:
                return true;

            default:
                return false;

        }

    }

}

export function filterAvailableTypes(types: IManureType[], region?: RegionId, retainBlends?: boolean) {

    if (!retainBlends) {
        types = types.filter(t => !isBlendType(t));
    }

    if (!isUndefinedOrNull(region)) {

        const filter = getRegionFilter(region)

        return types.filter(filter)

    }

    return types;

}

export function getRegionFilter(region: RegionId) {

    const v2018 = (region == RegionId.Scotland)
        ? (mt: IManureType) => mt.AvailableScotland !== false
        : (mt: IManureType) => mt.AvailableEngland !== false

    return (mt: IManureType) => {

        if (mt.Regions?.length) {
            return mt.Regions.some(r => (r.Region === region) && (!r.NotAvailable))
        }

        return v2018(mt)

    }

}

export function getManureTypeNVzNitrogen(type: IManureType, holdingRegion: RegionId) {
    const rt = type?.Regions?.find(r => r.Region === holdingRegion)
    return rt ? rt.NNvzAvailable : type.NNvzAvailable
}

export function setupManureTypesForRegion(types: IManureType[], region: RegionId) {

    return types.map(t => ({
        ...t,
        NNvzAvailable: getManureTypeNVzNitrogen(t, region)
    }))

}
